import { createSlice } from '@reduxjs/toolkit';
import { searchProducts } from './shop_service_syn';

const shopSlice = createSlice({
  name: 'shop',
  initialState: {
    products: {},
    loading: false,
    error: null,
    product_name: '',
    product_category: '',
    product_brand: '',
    totalProducts: 0,
    product_page: 0,
    product_limit: 12,
  },
  reducers: {
    updateProductPage: (state, { payload }) => {
      state.product_page = payload;
    },

    updateProductName: (state, { payload }) => {
      state.product_name = payload;
    },

    updateProductCategory: (state, { payload }) => {
      state.product_category = payload;
    },

    updateProductBrand: (state, { payload }) => {
      state.product_brand = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchProducts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.products = payload.data;
        state.totalProducts = payload?.data?.totalDocs;
        state.product_page = payload?.data?.page;
      })
      .addCase(searchProducts.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const {
  updateProductPage,
  updateProductName,
  updateProductCategory,
  updateProductBrand,
} = shopSlice.actions;
export default shopSlice.reducer;
